import React from 'react';
import { getOverriddenEnterpriseFeatureIds } from '~/common/api-client';
import useAPI, { type State as BaseState } from '~/common/hooks/useAPI';

interface State extends Omit<BaseState<string[]>, 'data'> {
  featureIds: string[];
  refresh: () => void;
}

const useOverriddenEnterpriseFeatureIds = (token: string): State => {
  const dataLoader = React.useCallback(
    () => getOverriddenEnterpriseFeatureIds(token),
    [token]
  );
  const state = useAPI(dataLoader);
  const featureIds = React.useMemo(
    () => state.data?.featureIds ?? [],
    [state.data]
  );
  return {
    error: state.error,
    loading: state.loading,
    featureIds,
    refresh: state.refresh
  };
};

export default useOverriddenEnterpriseFeatureIds;
